import { WSClient } from '@nablax/shared/lib';
import { EventNotification, SimpleNotification } from '@nablax/shared/types';

import { CONSTANTS } from '@/config/constants';

import { userManager } from './auth';

export const wsClient = new WSClient(
  userManager,
  (message: SimpleNotification | EventNotification | null) => {
    // avoid alerting on project setup completed simulations inside spaiderdemo application
    if (
      message &&
      'event' in message &&
      message.event === 'tasks:update' &&
      message.payload.payload?.type === CONSTANTS.tasks.projectSetupType
    ) {
      return { next: false };
    }
  },
);
